import React, { useEffect, useState } from "react";
import jsonExport from "jsonexport/dist";

import { useMediaQuery, Card, Typography } from "@material-ui/core";

import {
  downloadCSV,
  useList,
  useListContext,
  useNotify,
  useQueryWithStore,
  Button,
  Datagrid,
  FilterButton,
  ListContextProvider,
  ListToolbar,
  NumberField,
  RefreshButton,
  SelectInput,
  SimpleList,
  TextField,
  TopToolbar,
} from "react-admin";

import {
  ChevronRightIcon,
  ExportIcon,
} from "../../../components/common/iconography";
import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { Pagination } from "../../../components/Pagination";
import { SearchField } from "../../../components/common/SearchField";
import { logError } from "../../../utils/appUtils";
import { InventoryStatus } from "../../../utils/constants";
import { getTotalQuantityAvailable } from "../products/ProductUtils";

const exporter = (inventories) => {
  debugger;
  const inventoriesForExport = inventories.map((inventory) => {
    const inventoryForExport = {
      accountName: inventory.accountName,
      productCode: inventory.productCode,
      productName: inventory.productName,
      totalQuantityOnHand: inventory.totalQuantityOnHand,
      totalQuantityCommitted: inventory.totalQuantityCommitted,
      totalQuantityAvailable: inventory.totalQuantityAvailable,
      inventoryUOM: inventory.inventoryUOM,
    };
    debugger;

    return inventoryForExport;
  });

  jsonExport(
    inventoriesForExport,
    {
      rename: [
        "Customer",
        "Product Code",
        "Product",
        "On Hand",
        "Committed",
        "Available",
        "UOM",
      ],
    },
    (err, csv) => {
      downloadCSV(csv, `lowInventories_${new Date().toLocaleDateString()}`); // download as 'lowInventories_DATE.csv` file
    },
  );
};

const InventorySearchField = (props) => {
  const { setSearchTerm, label, alwaysOn } = props;

  const handleSearch = (value) => {
    const searchTerm = value?.toLowerCase() || "";
    setSearchTerm(searchTerm);
  };

  return (
    <SearchField
      id="searchTerm"
      label={label}
      margin="dense"
      variant="outlined"
      alwaysOn={alwaysOn}
      handleSearch={handleSearch}
    />
  );
};

const getListFilters = (isSmall, setSearchTerm) => [
  <InventorySearchField
    label="Search"
    alwaysOn
    setSearchTerm={setSearchTerm}
  />,
  <SelectInput
    source="reloadYardCommodityId"
    label="Load Type"
    variant="outlined"
    alwaysOn={!isSmall}
    resettable
    choices={window.appUser.reloadYard.activeYardCommodities.items}
    optionText="commodity.name"
  />,
];

const ListActions = (props) => {
  const { data } = useListContext();
  const inventories = Object.values(data);

  return (
    <TopToolbar>
      <FilterButton />
      <Button
        label="Export"
        disabled={inventories?.length === 0}
        onClick={() => exporter(inventories)}
      >
        <ExportIcon />
      </Button>
      <RefreshButton />
      <BackButton basePath="/reports" />
    </TopToolbar>
  );
};

export const LowInventoryList = (props) => {
  const notify = useNotify();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [searchTerm, setSearchTerm] = useState("");

  const fixedFilter = { lowInventoryAlert: true };
  const defaultSort = { field: "accountName", order: "ASC" };
  const defaultPerPage = 10;
  const searchInput = {
    filter: {
      searchInventorys: {
        reloadYardId: { eq: window.appUser?.reloadYardId },
        status: { eq: InventoryStatus.STORED },
        productId: { exists: true },
      },
    },
    pagination: { page: 1, perPage: 1000 },
    sort: defaultSort,
  };

  const [finalData, setFinalData] = useState([]);
  const { data, error, loaded, loading } = useQueryWithStore({
    type: "getList",
    resource: "inventories",
    payload: searchInput,
  });
  if (error)
    logError("inventory:LowInventoryList:useQueryWithStore", error, notify);

  useEffect(() => {
    debugger;
    if (data?.length > 0) {
      const dedupData = [
        ...new Map(
          data.map((item) => [
            item.productId,
            {
              id: item.id,
              accountName: item.accountName,
              productId: item.productId,
              productCode: item.productCode,
              productName: item.productName,
              category: item.product?.category,
              totalQuantityOnHand: item.product?.totalQuantityOnHand,
              totalQuantityCommitted: item.product?.totalQuantityCommitted,
              totalQuantityAvailable: getTotalQuantityAvailable(item.product),
              inventoryUOM: item.inventoryUOM,
              reloadYardCommodityId: item.reloadYardCommodityId,
              lowInventoryAlert: item.product?.lowInventoryAlert,
            },
          ]),
        ).values(),
      ];
      debugger;

      if (searchTerm) {
        const filteredData = dedupData.filter(
          (itm) =>
            itm.accountName?.toLowerCase().includes(searchTerm) ||
            itm.productName?.toLowerCase().includes(searchTerm) ||
            itm.productCode?.toLowerCase().includes(searchTerm) ||
            itm.category?.toLowerCase().includes(searchTerm),
        );
        setFinalData(filteredData);
      } else setFinalData(dedupData);
    } else setFinalData([]);
  }, [data, searchTerm]);

  const listContext = useList({
    ...props,
    data: finalData,
    ids: finalData.map(({ id }) => id),
    loading,
    loaded,
    filter: fixedFilter,
    sort: defaultSort,
    perPage: defaultPerPage,
    basePath: "/inventories",
    resource: "inventories",
  });

  return (
    <ListContextProvider value={listContext}>
      <div style={{ display: "none" }}>
        <ForceTitle title="Inventory" />
      </div>
      <ListToolbar
        {...props}
        filters={getListFilters(isSmall, setSearchTerm)}
        actions={<ListActions />}
      />
      <Card>
        <InventoryGrid />
        <Pagination {...listContext} />
      </Card>
    </ListContextProvider>
  );
};

const InventoryGrid = (props) => {
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));

  return isXSmall ? (
    <SimpleList
      {...props}
      primaryText={(record) => record.railCarNumber}
      secondaryText={(record) => (
        <>
          <Typography>{`${record.name}`}</Typography>
          <Typography color="textSecondary">{`${record.productCode}`}</Typography>
        </>
      )}
      tertiaryText={(record) =>
        `On hand: ${record.totalQuantityOnHand}, Available: ${record.totalQuantityAvailable}`
      }
      rightIcon={() => (
        <ChevronRightIcon
          fontSize="large"
          color="secondary"
          style={{ marginLeft: 40, marginTop: 10 }}
        />
      )}
      linkType="edit"
    />
  ) : (
    <Datagrid rowClick={false} {...props}>
      <TextField source="accountName" label="Account" />
      <TextField source="productCode" label="Product Code" />
      <TextField source="productName" label="Product Name" />
      <TextField source="category" label="Commodity Category" />
      <NumberField source="totalQuantityOnHand" label="On Hand" />
      <NumberField source="totalQuantityCommitted" label="Committed" />
      <NumberField source="totalQuantityAvailable" label="Available" />
      <TextField source="inventoryUOM" label="UOM" />
      <TextField source="lowInventoryAlert" label="UOM" />
    </Datagrid>
  );
};
